class formating {
  static formatWithPaymentField(value) {
    const formatedValue = value;
    return formatedValue;
  }
}
module.exports = formating;
